// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('Account # · Low to High'),
    value: { field: 'ACCOUNT_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Account # · High to Low'),
    value: { field: 'ACCOUNT_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Name · A to Z'),
    value: { field: 'NAME', direction: 'ASC' },
  },
  {
    label: i18n.t('Name · Z to A'),
    value: { field: 'NAME', direction: 'DESC' },
  },
  {
    label: i18n.t('Type · A to Z'),
    value: { field: 'ACCOUNT_TYPE', direction: 'ASC' },
  },
  {
    label: i18n.t('Type · Z to A'),
    value: { field: 'ACCOUNT_TYPE', direction: 'DESC' },
  },
  {
    label: i18n.t('Recently Updated'),
    value: { field: 'UPDATED_AT', direction: 'DESC' },
  },
  {
    label: i18n.t('Recently Created'),
    value: { field: 'CREATED_AT', direction: 'DESC' },
  },
];
